export enum UnitType {
  KWH = 'KWH',

  M3 = 'M3',
}
